import React from "react";
import { FormattedMessage } from "react-intl";
import { Row, Space, Select } from "@masterteam/mt-design-react";

import AsyncSvg from "../../AsyncSvg";
import ObjectiveCard from "./ObjectiveCard";

import useIsAr from "../../../Hooks/useIsAr";

import { ReactComponent as LevelOneIcon } from "../../../assets/images/level-one.svg";
import { ReactComponent as LevelTwoIcon } from "../../../assets/images/level-two.svg";
import { ReactComponent as ObjectivesIcon } from "../../../assets/images/sub-objectives-icon.svg";

import "./style.scss";

const ObjectivesCards = ({
  strategy,
  statuses,
  projectStatuses,
  orgStructure,
  selectedSectors,
  levelOneSelected,
  levelTwoSelected,
  setSelectedSectors,
  setLevelOneSelected,
  setLevelTwoSelected,
  selectedThemePillar,
  initiativeStatus
}) => {
  const [isAr] = useIsAr();
  let data = [...strategy?.Perspectives];
  const isStrategic = +strategy?.StrategyType === 1;

  if (selectedThemePillar)
    data = data.map((e) => {
      return {
        ...e,
        Objectives: e.Objectives.filter(
          (o) => o.ParentLevelID === selectedThemePillar.ID
        ),
      };
    });

  if (isStrategic && (levelOneSelected || levelTwoSelected))
    data = data.map((e) => {
      return {
        ...e,
        Objectives: e.Objectives.filter(
          (o) =>
            (+o.Level === 1 && levelOneSelected) ||
            (+o.Level === 2 && levelTwoSelected)
        ),
      };
    });

  if (isStrategic && selectedSectors.length) {
    const sectorsIDs = selectedSectors.map((sector) => sector.ID);

    data = data.map((e) => {
      return {
        ...e,
        Objectives: e.Objectives.filter((o) =>
          o?.SectorIDs?.some((element) => sectorsIDs?.includes(element))
        ),
      };
    });
  }

  return (
    <Space size="large" direction="vertical" className="objectives-cards ">
      <Row size="large" align="stretch">
        <div className="objectives-cards__perspectives">
          <FormattedMessage id="common.perspectives" />
        </div>

        <Row
          justify="between"
          align="center"
          className="objectives-cards__objectives-header"
        >
          <Space align="center">
            <ObjectivesIcon width={20} height={20} fill="#444444" />

            <FormattedMessage id="common.strategic-objectives" />
          </Space>

          {isStrategic ? (
            <Space align="center" size="large" className="filters-wrapper">
              <div className="gray-line" />

              <Space
                align="center"
                className="cursor"
                style={{
                  color: levelOneSelected ? "var(--primary-color)" : "#444444",
                }}
                onClick={() => setLevelOneSelected(!levelOneSelected)}
              >
                <LevelOneIcon
                  fill={levelOneSelected ? "var(--primary-color)" : "#616161"}
                />

                <FormattedMessage id="common.level-one" />
              </Space>

              <Space
                align="center"
                className="cursor"
                style={{
                  color: levelTwoSelected ? "var(--primary-color)" : "#444444",
                }}
                onClick={() => setLevelTwoSelected(!levelTwoSelected)}
              >
                <LevelTwoIcon
                  fill={levelTwoSelected ? "var(--primary-color)" : "#616161"}
                />

                <FormattedMessage id="common.level-two" />
              </Space>

              <div className="gray-line" />

              <div className="sectors-wrapper">
                <FormattedMessage id="common.sectors" />
                <Select
                  options={orgStructure}
                  menuPlacement="top"
                  placeholder={<FormattedMessage id="common.select" />}
                  getOptionLabel={(el) =>
                    isAr ? el.ArabicName : el.EnglishName
                  }
                  getOptionValue={(el) => el?.ID}
                  onChange={(item) => {
                    setSelectedSectors(item);
                  }}
                  value={selectedSectors}
                  isMulti
                />
              </div>
            </Space>
          ) : null}
        </Row>
      </Row>

      <Space
        size="large"
        direction="vertical"
        className="objectives-cards__cards custom-scrollbar"
      >
        {data?.length ? (
          data?.map((item) => (
            <Row
              align="stretch"
              size="large"
              className="objectives-cards__row"
              key={item.ID}
            >
              <div className="perspective-wrapper">
                <div className="perspective">
                  <AsyncSvg
                    attachment={item.Attachment}
                    color="white"
                    style={{
                      width: 30,
                      height: 30,
                      background:
                        "linear-gradient(-60.89deg, #007dc5 0%, #007dc5 27.3%, #00ae5f 100%)",
                    }}
                  />
                  <div>{isAr ? item?.ArabicName : item?.EnglishName}</div>
                </div>
              </div>

              <Space size="large">
                {item?.Objectives?.map((e) => (
                  <ObjectiveCard
                    data={e}
                    statuses={statuses?.filter(status => status.Code !==  "NA")}
                    projectStatuses={projectStatuses}
                    key={e.ID}
                    isStrategic={isStrategic}
                    initiativeStatus={initiativeStatus}
                  />
                ))}
              </Space>
            </Row>
          ))
        ) : (
          <Row
            justify="center"
            align="center"
            style={{ height: "100%", padding: "16px 0", fontSize: "16px" }}
          >
            <FormattedMessage id="no-data" />
          </Row>
        )}
      </Space>
    </Space>
  );
};

export default ObjectivesCards;
